import { render, staticRenderFns } from "./PolizaContractual.vue?vue&type=template&id=c019f12a&scoped=true"
import script from "./PolizaContractual.vue?vue&type=script&lang=js"
export * from "./PolizaContractual.vue?vue&type=script&lang=js"
import style0 from "./PolizaContractual.vue?vue&type=style&index=0&id=c019f12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c019f12a",
  null
  
)

export default component.exports